export default "__VITE_ASSET__Bt9OFqT0__"